import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部待结算金额");

const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "系统核销金额", -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin-left": "10px"
  }
}, "此处结算金额为实际线下结算金额，若不填写，即视为与系统一致", -1);

const _hoisted_4 = /*#__PURE__*/_createTextVNode("自动勾兑订单");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("手动勾兑订单");

const _hoisted_6 = {
  key: 0
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "勾兑规则", -1);

const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "1.勾兑时间段内分账参与方分账订单", -1);

const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "2.根据订单时间由远至近勾兑", -1);

const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "3.若存在金额不足以勾兑一笔完整分账订单，即最后一笔视为部分结算", -1);

const _hoisted_11 = [_hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10];
const _hoisted_12 = {
  key: 0,
  class: "table"
};
const _hoisted_13 = {
  class: "toolbox",
  style: {
    "margin-bottom": "0"
  }
};
const _hoisted_14 = {
  class: "wrapper"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "label",
  style: {
    "flex": "0 0 170px"
  }
}, "已勾选订单涉及分账金额:", -1);

const _hoisted_16 = {
  style: {
    "white-space": "nowrap"
  }
};
const _hoisted_17 = {
  class: "wrapper"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "订单编号", -1);

const _hoisted_19 = {
  class: "wrapper"
};

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "客户名称", -1);

const _hoisted_21 = {
  class: "wrapper"
};

const _hoisted_22 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_24 = ["onClick"];

const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import Axios from '@/request/createAxiosInstalce';
import { ElMessageBox, ElMessage } from 'element-plus';
export default {
  name: 'settle-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    supplierId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        form.value = {
          settlementAmount: undefined,
          actualSettlementPrice: undefined,
          note: '',
          blendType: 1,
          orderCodes: []
        };
        reset();
        formEl.value && formEl.value.resetFields();
      }
    });
    const form = ref({
      settlementAmount: undefined,
      actualSettlementPrice: undefined,
      note: '',
      blendType: 1,
      orderCodes: []
    });
    const formEl = ref();
    const rules = {
      settlementAmount: [{
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error('请填写结算金额'));
          } else if (value > props.data.unSettlementAmount) {
            callback(new Error('输入值不可大于待结算金额'));
          }

          callback();
        }
      }],
      blendType: {
        required: true
      }
    };

    function resetFormFields(field, value) {
      // formEl.value.clearValidate(field)
      form.value[field] = parseFloat(value);
    }

    function submit() {
      formEl.value.validate(valid => {
        if (!valid) return;

        let body = _objectSpread({
          participateId: props.data.participateId,
          participateName: props.data.participateName,
          participateRole: props.data.participateRole,
          supplierId: props.supplierId,
          startDate: props.data.startTime,
          endDate: props.data.endTime
        }, form.value);

        Axios.post('/admin/split/settlement/blend.json', body).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            emits('success');
            visible.value = false;
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    const table = ref([]);
    const tableSeach = ref({
      orderCode: '',
      custName: ''
    });
    const tableSelectedList = ref([]);
    const totalCount = computed(() => {
      if (tableSelectedList.value.length) {
        return tableSelectedList.value.reduce((pre, cur) => {
          return pre + parseFloat(cur.splitAmount);
        }, 0);
      }

      return 0;
    });

    function getList() {
      let params = _objectSpread({
        participateRole: props.data.participateRole,
        participateId: props.data.participateId,
        startDate: props.data.startTime,
        endDate: props.data.endTime,
        supplierId: props.supplierId
      }, tableSeach.value);

      Axios.get('/admin/split/settlement/getBlendOrders.json', {
        params
      }).then(res => {
        table.value = res.data.data;
      });
    }

    function reset() {
      tableSeach.value = {
        orderCode: '',
        custName: ''
      };
      getList();
    }

    function tableSelect(list) {
      console.log(list);
      tableSelectedList.value = list;
      form.value.orderCodes = list.map(v => v.orderCode);
    }

    function toOrder(orderCode) {
      let href = router.resolve({
        name: 'TeamOrder',
        query: {
          orderCode
        }
      }).href;
      window.open(href, '_blank');
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "结算",
        width: "80%",
        top: "5vh",
        "custom-class": "account-settle-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 1
        })]),
        default: _withCtx(() => [_unref(visible) ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref_key: "formEl",
          ref: formEl,
          model: form.value,
          rules: rules,
          "label-width": 120
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "时间："
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(props.data.startTime) + " ~ " + _toDisplayString(props.data.endTime), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分账参与方："
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(props.data.participateName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "待结算金额："
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, "￥" + _toDisplayString(props.data.unSettlementAmount), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "(系统)结算金额",
            prop: "settlementAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.settlementAmount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.settlementAmount = $event),
              min: 0,
              precision: 2
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {
                "margin": "0 10px"
              },
              onClick: _cache[1] || (_cache[1] = $event => resetFormFields('settlementAmount', props.data.unSettlementAmount))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _hoisted_2]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "实际结算金额"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.actualSettlementPrice,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.actualSettlementPrice = $event),
              min: 0,
              precision: 2
            }, null, 8, ["modelValue"]), _hoisted_3]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.note,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.note = $event),
              type: "textarea",
              maxLength: 50,
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "勾兑订单",
            prop: "blendType"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
              modelValue: form.value.blendType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.blendType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_4]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), form.value.blendType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_11)) : _createCommentVNode("", true)])]),
            _: 1
          }), form.value.blendType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", _hoisted_16, "￥" + _toDisplayString(_unref(totalCount)), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_input, {
            modelValue: tableSeach.value.orderCode,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => tableSeach.value.orderCode = $event),
            placeholder: "请输入订单编号"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_input, {
            modelValue: tableSeach.value.custName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => tableSeach.value.custName = $event),
            placeholder: "请输入客户名称"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getList
          }, {
            default: _withCtx(() => [_hoisted_22]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_23]),
            _: 1
          })])]), _createVNode(_component_el_table, {
            data: table.value,
            onSelectionChange: tableSelect
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }), _createVNode(_component_el_table_column, {
              label: "订单编号",
              prop: "orderCode"
            }, {
              default: _withCtx(scope => [_createElementVNode("a", {
                href: "javascript:;",
                onClick: $event => toOrder(scope.row.orderCode)
              }, _toDisplayString(scope.row.orderCode), 9, _hoisted_24)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "客户名称",
              prop: "custName"
            }), _createVNode(_component_el_table_column, {
              label: "下单时间",
              prop: "orderTime"
            }), _createVNode(_component_el_table_column, {
              label: "分账金额(元)",
              prop: "splitAmount"
            }), _createVNode(_component_el_table_column, {
              label: "待结算金额(元)",
              prop: "unSettlementAmount"
            }), _createVNode(_component_el_table_column, {
              label: "支付方式",
              prop: "payMethodName"
            }), _createVNode(_component_el_table_column, {
              label: "订单状态",
              prop: "orderStateName"
            }), _createVNode(_component_el_table_column, {
              label: "回款状态",
              prop: "repaymentStatusName"
            })]),
            _: 1
          }, 8, ["data"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};